/** Class names for analytics tagging.
 * These values MUST NOT BE CHANGED without coordinating with analytics,
 * since the values are tied to registered analytic events.
 * */

/** Shipping */
export const ALERT_DELIVERY_OPTS_ERR_TAG = 'alert-delivery-options-error';
export const ALERT_NO_DELIVERY_OPTS_ERR_TAG = 'alert-no-delivery-options-error';
